function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrincipalFinancialGroup = function SvgPrincipalFinancialGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 131 38",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-443,-29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M571.63,36.511L570.53,38.004L569.436,36.511L568.963,36.511L568.963,39.73L569.45,39.73L569.45,37.315L570.384,38.59L570.674,38.59L571.615,37.313L571.615,39.73L572.102,39.73L572.102,36.511L571.63,36.511ZM568.171,38.875C568.171,39.408 567.655,39.802 567.007,39.785C566.398,39.773 565.824,39.516 565.824,39.516L565.958,39.089C565.958,39.089 566.544,39.348 566.981,39.343C567.391,39.338 567.655,39.158 567.655,38.875C567.655,38.532 567.312,38.436 566.906,38.318C566.417,38.177 565.858,38.014 565.858,37.351C565.858,36.823 566.328,36.475 567.007,36.458C567.494,36.444 568.078,36.689 568.078,36.689L567.943,37.114C567.943,37.114 567.41,36.888 567.034,36.898C566.63,36.912 566.369,37.075 566.369,37.351C566.369,37.673 566.71,37.774 567.106,37.884C567.605,38.026 568.171,38.189 568.171,38.875Z",
    style: {
      fill: "rgb(88,89,93)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.027,48.478C556.027,50.357 554.918,51.463 553.092,51.463C551.746,51.463 550.927,50.741 550.927,49.586C550.927,48.288 551.986,47.515 553.764,47.515C554.63,47.515 555.305,47.611 556.027,47.758L556.027,48.478ZM556.027,46.121C555.305,45.926 554.342,45.833 553.476,45.833C550.397,45.833 548.566,47.323 548.566,49.778C548.566,51.946 550.301,53.388 552.802,53.388C554.294,53.388 555.499,52.812 556.315,51.799C556.654,52.812 557.518,53.388 558.674,53.388C559.157,53.388 559.685,53.292 560.021,53.148L559.781,51.317C559.591,51.365 559.349,51.415 559.157,51.415C558.578,51.415 558.336,51.125 558.336,50.549L558.336,45.494C558.336,42.799 556.558,41.162 553.62,41.162C552.175,41.162 550.538,41.546 549.142,42.221L549.864,44.1C550.877,43.522 552.082,43.183 553.236,43.183C555.062,43.183 556.027,44.004 556.027,45.59L556.027,46.121ZM533.213,41.453L530.856,41.453L530.856,53.147L533.213,53.147L533.213,41.453ZM532.058,39.768C532.922,39.768 533.551,39.142 533.551,38.275C533.551,37.409 532.922,36.785 532.058,36.785C531.192,36.785 530.52,37.409 530.52,38.275C530.52,39.142 531.192,39.768 532.058,39.768ZM564.881,51.365C564.065,51.365 563.777,51.031 563.777,50.114L563.777,36.492L561.415,36.492L561.415,50.453C561.415,52.33 562.476,53.388 564.449,53.388C564.931,53.388 565.459,53.292 565.795,53.148L565.555,51.271C565.363,51.317 565.073,51.365 564.881,51.365ZM524.741,43.277C525.706,43.277 526.814,43.714 527.729,44.388L528.785,42.655C527.729,41.741 526.14,41.162 524.647,41.162C521.23,41.162 518.726,43.714 518.726,47.275C518.726,50.981 521.038,53.388 524.501,53.388C526.14,53.388 527.825,52.812 528.785,51.898L527.729,50.21C526.86,50.93 525.9,51.271 524.837,51.271C522.578,51.271 521.131,49.73 521.131,47.275C521.131,44.87 522.578,43.277 524.741,43.277ZM512.47,41.162C510.931,41.162 509.582,41.837 508.716,42.943L508.524,41.453L506.549,41.453L506.549,53.148L508.908,53.148L508.908,46.601C508.908,44.628 510.158,43.277 511.942,43.277C513.528,43.277 514.541,44.292 514.541,45.878L514.541,53.148L516.898,53.148L516.898,45.59C516.898,42.943 515.117,41.162 512.47,41.162ZM503.47,53.148L503.47,49.826L503.47,41.453L501.113,41.453L501.113,53.148L503.47,53.148ZM502.315,39.768C503.182,39.768 503.808,39.142 503.808,38.275C503.808,37.409 503.182,36.785 502.315,36.785C501.449,36.785 500.774,37.409 500.774,38.275C500.774,39.142 501.449,39.768 502.315,39.768ZM497.693,41.261C496.346,41.261 495.096,41.882 494.422,42.943L494.23,41.453L492.254,41.453L492.254,53.148L494.614,53.148L494.614,46.843C494.614,44.58 495.674,43.38 497.693,43.38C498.034,43.38 498.514,43.471 498.994,43.57L499.284,41.546C498.802,41.354 498.271,41.261 497.693,41.261ZM481.716,39.288L484.651,39.288C486.866,39.288 488.165,40.392 488.165,42.365C488.165,44.34 486.866,45.446 484.651,45.446L481.716,45.446L481.716,39.288ZM479.261,37.217L479.261,53.148L481.716,53.148L481.716,47.515L484.987,47.515C488.357,47.515 490.62,45.446 490.62,42.365C490.62,39.288 488.357,37.217 484.987,37.217L479.261,37.217ZM541.397,51.271C540.336,51.271 539.182,50.741 538.603,50.021L538.603,46.502C538.603,44.532 539.808,43.277 541.634,43.277C543.562,43.277 544.764,44.726 544.764,47.035C544.764,49.73 543.514,51.271 541.397,51.271ZM542.117,41.162C540.624,41.162 539.23,41.789 538.363,42.943L538.171,41.453L536.198,41.453L536.198,57.864L538.555,57.864L538.555,52.234C539.275,52.908 540.624,53.388 541.778,53.388C545.004,53.388 547.171,50.789 547.171,47.035C547.171,43.522 545.148,41.162 542.117,41.162Z",
    style: {
      fill: "rgb(88,89,93)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.394,46.634C444.394,56.57 452.016,64.865 461.904,65.786L461.904,53.146C457.272,52.711 454.09,49.289 454.09,44.755C454.09,40.363 457.032,37.181 461.083,37.181C464.796,37.181 467.306,39.497 467.306,42.922C467.306,45.96 465.377,47.94 461.904,48.468L461.904,53.146C469.042,52.954 473.674,48.614 473.674,42.098C473.674,35.057 468.175,29.897 460.651,29.897C451.39,29.897 444.394,37.13 444.394,46.634Z",
    style: {
      fill: "url(#_Linear1)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(17.1017,-29.6212,29.6212,17.1017,449.262,60.5265)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(0,115,192)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    style: {
      stopColor: "rgb(0,122,195)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "rgb(11,129,199)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "rgb(22,136,203)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    style: {
      stopColor: "rgb(33,143,207)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(45,151,211)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    style: {
      stopColor: "rgb(46,161,213)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(48,171,214)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "rgb(50,180,215)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(53,190,215)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(55,199,216)",
      stopOpacity: 1
    }
  }))));
};
export default SvgPrincipalFinancialGroup;